// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"Eyebrow_eyebrow__C0IR6","eyebrow--size-md":"Eyebrow_eyebrow--size-md___cMTI"};